module.exports = __webpack_public_path__ + "img/59.d1b44eb8.jpg";